// Generated by Melange

import * as Caml_int32 from "melange.js/caml_int32.jsx";
import * as Fx from "../fx/fx.jsx";
import * as Stdlib__Fun from "melange/fun.jsx";
import * as Stdlib__Option from "melange/option.jsx";
import * as StoreFx__Play from "./play.jsx";
import * as StoreFx__SetCurrentTime from "./setCurrentTime.jsx";
import * as StoreFx__StartPlaying from "./startPlaying.jsx";

function make(param) {
  return Fx.Monad_syntax.let$star(Fx.ask(undefined), (function (param) {
    const state = param.store.getState();
    if (state.player.currentTime > 3.0) {
      return Fx.Monad_syntax.let$star(StoreFx__SetCurrentTime.make(function (param) {
        return Stdlib__Fun.$$const(0.0, param);
      }), (function (param) {
        return StoreFx__Play.make(undefined);
      }));
    }
    const queued = state.player.queuedSongIds;
    const len = queued.length;
    const currentIndex = Stdlib__Option.value(Stdlib__Option.map((function (value) {
      return queued.indexOf(value, undefined);
    }), state.player.currentSongId), 0);
    const current = queued[Caml_int32.mod_((len + currentIndex | 0) - 1 | 0, len)];
    return StoreFx__StartPlaying.make(current, undefined, undefined);
  }));
}

export {
  make,
}
/* Stdlib__Fun Not a pure module */
